<template>
	<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
		stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
		<path d="M23 6l-9.5 9.5-5-5L1 18" />
		<path d="M17 6h6v6" />
	</svg>
</template>

<script>
export default {
	name: "IconSales",
};
</script>
